import styled from 'styled-components'

export const WeatherContainer = styled.div`
   margin: 1rem;
   position: absolute;
`

export const Temp = styled.p`
  font-size: 2rem;
  color: #fff;
  margin: 0;
`
export const City = styled.p`
   text-align: center;
   margin: 4px 0;
`